import React from 'react';
import PropTypes from 'prop-types';
import WinsRuns from './WinsRuns';
import SinceWin from './SinceWin';

const Header = ({ profileType, winsRuns, sinceWin, upcomingEntries }) => (
    <div className="mp-form__header">
        <h2 className="mp-form__title">Last 14 days</h2>
        {(winsRuns.runs || upcomingEntries) && (
            <div className="mp-form__info">
                {winsRuns.runs ? <WinsRuns profileType={profileType} {...winsRuns} /> : null}
                <SinceWin profileType={profileType} {...sinceWin.flat} type="flat" />
                <SinceWin profileType={profileType} {...sinceWin.jumps} type="jumps" />
            </div>
        )}
    </div>
);

Header.defaultProps = {
    winsRuns: {},
};

Header.propTypes = {
    profileType: PropTypes.string.isRequired,
    upcomingEntries: PropTypes.bool,
    sinceWin: PropTypes.shape({
        flat: PropTypes.shape({
            days: PropTypes.number,
            runs: PropTypes.number,
        }),
        jumps: PropTypes.shape({
            days: PropTypes.number,
            runs: PropTypes.number,
        }),
    }),
    winsRuns: PropTypes.shape({
        wins: PropTypes.number,
        runs: PropTypes.number,
        percent: PropTypes.number,
    }),
};

export default Header;



// WEBPACK FOOTER //
// ./src/js/human/form/components/Header.jsx